import { alovaInstanceOnboarding } from '@admission/apis/onboarding/alovaInstanceOnboarding';
import { useRequest } from 'alova';

import { CustomerResponseProps } from './types';

const headers = {
  'Content-Type': 'application/json;charset=UTF-8',
  'Access-Control-Allow-Origin': '*',
};

const useApiOnboarding = () => {
  const apiOnboardingCustomer = useRequest(
    () =>
      alovaInstanceOnboarding.Get<CustomerResponseProps>('/marketplace/v1/app/customer', {
        headers: {
          ...headers,
        },
        localCache: null,
      }),
    {
      immediate: false,
    }
  );

  const apiOnboardingCustomerUpdate = useRequest(
    (payload) =>
      alovaInstanceOnboarding.Put(
        '/marketplace/v1/app/customer/update',
        payload
      ),
    {
      immediate: false,
    }
  );

  return {
    apiOnboardingCustomer,
    apiOnboardingCustomerUpdate,
  };
};

export default useApiOnboarding;
